"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsMobile = exports.useIsMobile = exports.getInitialMobileState = void 0;
var react_1 = __importDefault(require("react"));
// Simplified mobile detection for iframe context
// Always trusts the parent window's screen info
// Global flag to store mobile state from parent
var mobileStateFromParent = null;
// Function to detect mobile from user agent as fallback
var detectMobileFromUA = function () {
    var ua = navigator.userAgent.toLowerCase();
    return /mobile|android|iphone|ipad|ipod|blackberry|windows phone/i.test(ua);
};
// Function to get initial mobile state
// Uses user agent detection as fallback (more reliable than defaulting to mobile)
var getInitialMobileState = function () {
    // If parent hasn't sent info yet, use user agent detection instead of defaulting to mobile
    if (mobileStateFromParent === null) {
        return detectMobileFromUA();
    }
    return mobileStateFromParent;
};
exports.getInitialMobileState = getInitialMobileState;
// Hook for React components - simplified to only listen to parent messages
var useIsMobile = function () {
    var _a = react_1.default.useState(exports.getInitialMobileState), mobile = _a[0], setMobile = _a[1];
    var timeoutRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        // Listen for screen info from parent window with debouncing
        var handleMessage = function (event) {
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === "SCREEN_INFO") {
                // Clear any existing timeout
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                // Debounce the message handling
                timeoutRef.current = setTimeout(function () {
                    var newIsMobile = event.data.isMobile;
                    mobileStateFromParent = newIsMobile;
                    setMobile(newIsMobile);
                    console.log("Mobile state updated from parent:", newIsMobile, "UA detected:", event.data.isMobileByUA);
                }, 100);
            }
        };
        window.addEventListener("message", handleMessage);
        return function () {
            window.removeEventListener("message", handleMessage);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return mobile;
};
exports.useIsMobile = useIsMobile;
// For non-React contexts
var getIsMobile = function () {
    // Use user agent detection as fallback instead of defaulting to true
    return mobileStateFromParent !== null && mobileStateFromParent !== void 0 ? mobileStateFromParent : detectMobileFromUA();
};
exports.getIsMobile = getIsMobile;
